import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;
export const PUBLIC_API = `${BACKEND_URL}/api`;

const adminApi = axios.create({ baseURL: ADMIN_API, timeout: 180000 });

adminApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("vita_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("vita_admin_token");
    }
    return Promise.reject(err);
  }
);

export default adminApi;
